module.exports = __webpack_public_path__ + "img/logo_color.5e66d394.png";